var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3090_18959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91536 2.67081L7.32786 2.08331L4.9987 4.41248L2.66953 2.08331L2.08203 2.67081L4.4112 4.99998L2.08203 7.32915L2.66953 7.91665L4.9987 5.58748L7.32786 7.91665L7.91536 7.32915L5.5862 4.99998L7.91536 2.67081Z",
    fill: "#A5B4C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3090_18959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniClose);
export default __webpack_public_path__ + "static/media/miniClose.16b94c712aaf6afc4b658016bd6724b7.svg";
export { ForwardRef as ReactComponent };